import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getIssues, deleteIssue } from "../../api/issuesApi";
import { translateAuthError, API_ORIGIN } from "../../api/authApi";
import { toPersianOrdinal } from "../../utils/persianDigits";

// Section C (admin-only): lists every دریچه issue cover shown on the
// public نشریه‌ها page, with manage-cards/edit/delete actions and a link
// to upload a new one.
function AdminIssuesPage() {
  const [issues, setIssues] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    getIssues()
      .then(setIssues)
      .catch((err) => setError(translateAuthError(err.message)))
      .finally(() => setLoading(false));
  }, []);

  async function handleDelete(id) {
    if (!window.confirm("این شماره حذف شود؟")) return;
    try {
      await deleteIssue(token, id);
      setIssues((prev) => prev.filter((issue) => issue.id !== id));
    } catch (err) {
      setError(translateAuthError(err.message));
    }
  }

  return (
    <div className="admin-page">
      <Link to="/admin" className="back-link">
        ← بازگشت به پنل مدیریت
      </Link>

      <div className="admin-page-header">
        <h1>مدیریت شماره‌های نشریه</h1>
        <Link to="/admin/issues/new" className="nav-cta">
          بارگذاری شمارهٔ جدید
        </Link>
      </div>

      {error && <p className="error">{error}</p>}

      {!loading && issues.length === 0 && !error && <p className="admin-empty">هنوز شماره‌ای ثبت نشده است.</p>}

      <ul className="admin-article-list">
        {issues.map((issue) => (
          <li key={issue.id} className="admin-article-row">
            <div className="admin-issue-info">
              <img
                src={`${API_ORIGIN}${issue.image_path}`}
                alt={`جلد شمارهٔ ${issue.title}`}
                className="admin-issue-thumb"
              />
              <span>
                شمارهٔ {toPersianOrdinal(issue.number)} — {issue.title}
              </span>
            </div>
            <div className="admin-actions">
              <button type="button" onClick={() => navigate(`/admin/issues/${issue.id}/topics`)}>
                مدیریت کارت‌ها
              </button>
              <button type="button" onClick={() => navigate(`/admin/issues/${issue.id}/edit`)}>
                ویرایش
              </button>
              <button type="button" onClick={() => handleDelete(issue.id)}>
                حذف
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default AdminIssuesPage;
